import { Component, computed, inject, output, signal, ChangeDetectionStrategy } from '@angular/core';

import { ButtonComponent } from '@sirius/common';
import { MatchmakingTranslateService } from 'matchmaking/services';

@Component({
    selector: 'matchmaking-form-show-more-less-button',
    imports: [ButtonComponent],
    templateUrl: './form-show-more-less-button.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './form-show-more-less-button.component.scss'
})
export class FormShowMoreLessButtonComponent {
    private translateService = inject(MatchmakingTranslateService);

    toggler = output<boolean>();
    isShowMore = signal(true);

    translations = computed(() => this.translateService.translations());

    toggleEvent() {
        this.toggler.emit(this.isShowMore());
        this.isShowMore.update((val) => !val);
    }
}
